<template>
    <div id="login-wrap">
        <div class="form-wrap">
            <div class="rush-brand-container mx-auto">
                <img
                    src="../assets/images/rush-logo.png"
                    alt="RUSH"
                    class="rush-brand mb-5">
            </div>
            <b-form>
                <h3 class="mb-5">Reset Password</h3>
                <b-alert :show="loading" variant="warning">Processing...</b-alert>
                <b-alert variant="danger" :show="errors.message">{{ errors.message }}</b-alert>
                <b-alert variant="success" :show="message">{{ message }}</b-alert>
            </b-form>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ResetPasswordPage",
    computed: {
        ...mapState("auth", ["loading", "message", "errors"])
    },
    created() {
        this.$store.dispatch("auth/resetToken", this.$route.params.token);
    }
};
</script>

<style scoped>
</style>
